import React from 'react'
import _ from 'lodash'

class DialogTester extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      confirmed: null,
      alerted: null,
      prompt: null
    }
  }

  render() {

    const { confirmed, alerted, prompt } = this.state;

    return (
      <div className="DialogTester">
        <h1>Dialog Test:</h1>
        <div>
          <h3>Alert Test</h3>
          <button className="pt-button pt-intent-primary" onClick={() => this.onOpenAlert()}>Open alert</button>
          <p className="alert-response">
            {!_.isNull(alerted) && (
              alerted ? "Alert dismissed." : "Alert dismissed."
            )}
          </p>
        </div>
        <hr />
        <div>
          <h3>Confirm Test</h3>
          <button className="pt-button pt-intent-primary" onClick={() => this.onOpenDialog()}>Open Dialog</button>
          <p className="confirm-response">
            {!_.isNull(confirmed) && (
              confirmed ? "Dialog confirmed." : "Dialog cancelled."
            )}
          </p>
        </div>
        <hr />
        <div>
          <h3>Prompt Test</h3>
          <button className="pt-button pt-intent-primary" onClick={() => this.onPrompt()}>Open Prompt</button>
          <p className="prompt-response">
            {!_.isNull(prompt) && (
              prompt
            )}
          </p>
        </div>
      </div>
    )
  }

  onOpenAlert() {
    alert("HEYA!")
    this.setState({alerted: true});
  }

  onOpenDialog() {
    if (confirm("Confirm or cancel me!")) {
      this.setState({confirmed: true});
    } else {
      this.setState({confirmed: false});
    }
  }

  onPrompt() {
    var promptResult = prompt("Enter prompt:");

    this.setState({
      prompt: promptResult
    })
  }

}

export default DialogTester;



// WEBPACK FOOTER //
// ./src/components/testplayground/DialogTester.js